import React, { Fragment } from 'react';

const SelectField = (props) => {
    const changeHandler = (event) => {
        let value = event.target.value;
        props.setFunction(value);
    };

    const requiredHtml = props.required ? <Fragment> <span className="required">*</span></Fragment> : null;
    return (
        <div className="variable">
            <div className="label">{props.label}{requiredHtml}:</div>
            <select value={props.value} onChange={changeHandler} disabled={props.disabled}>
                {props.options.map((option) => {
                    return <option key={option.value} value={option.value}>{option.label}</option>;
                })}
            </select>
        </div>
    );
}

export default SelectField;